import { useEffect, useRef, useState } from "react";
import { Carousel, CarouselProps } from "@mantine/carousel";
import { Box, Card, Text } from "@mantine/core";
import { ReviewContent } from "src/graphql/generated/graphql";

export interface ContentProps {
    reviewContent: ReviewContent;
    onHeightChange?(height: number);
}

export const Content = ({ reviewContent, onHeightChange }: ContentProps) => {
    const containerRef = useRef<HTMLDivElement>();

    useEffect(() => {
        onHeightChange?.(containerRef?.current?.clientHeight);
    }, [onHeightChange, containerRef?.current?.clientHeight]);

    return (
        <Card
            ref={containerRef}
            radius="md"
            withBorder
        >
            <Box mb="sm">
                <Text weight={500}>
                    {reviewContent?.destination?.name}
                </Text>
            </Box>
            {reviewContent?.content}
        </Card>
    );
};

export interface ContentsProps extends CarouselProps {
    contents: ReviewContent[];
}

export const Contents = ({ contents, ...rest }: ContentsProps) => {
    const [height, setHeight] = useState(172);

    return (
        <Carousel
            {...rest}
            slideSize="40%"
            align="start"
            slideGap="md"
            height={height}
            controlSize={32}
            dragFree
            withIndicators
        >
            {(contents || []).map((reviewContent, index) => (
                <Carousel.Slide key={`${index}${reviewContent?.destination?.type}`}>
                    <Content
                        reviewContent={reviewContent}
                        onHeightChange={height =>
                            setHeight(currentHeight => height > currentHeight ? height + 4 : currentHeight)}
                    />
                </Carousel.Slide>
            ))}
        </Carousel>
    );
};
